import { PANEL_CODE_LANGUAGES } from '@experiment-management-shared/constants/chartsGallery';
import { parseJSON } from '@shared/utils/jsonHelpers';

export const parsePyConfigOfTemplate = template => {
  template.code.pyConfig = parseJSON(template.code.pyConfig, {});
  template.code.type = template.code.type || PANEL_CODE_LANGUAGES.JAVASCRIPT;

  return template;
};
